import { reducerWithoutInitialState } from "typescript-fsa-reducers";
import { AnyAction, Middleware } from "redux";

import { go, pushState, replaceState } from "../actions/Router";
import { History } from "history";

function routerMiddleware(history: History) {
  const routerReducer = reducerWithoutInitialState()
    .case(go, (state, action) => {
      history.go(action.to);
      return state;
    })
    .case(pushState, (state, action) => {
      history.push(action.path);
      return state;
    })
    .case(replaceState, (state, action) => {
      history.replace(action.path);
      return state;
    });

  return ((() => (next: any) => (action: AnyAction) => {
    if (action.type.indexOf("ROUTER/") === 0) {
      routerReducer({}, action);
    }
    return next(action);
  }) as any) as Middleware;
}

export default routerMiddleware;



// WEBPACK FOOTER //
// ./frontend/src/common/middlewares/routerMiddleware.ts